import { Controller } from "@hotwired/stimulus";

// Dispatches "bottom-sheet:open" on window so the bottom sheet controller can open.
// Usage: data-controller="bottom-sheet-trigger" data-action="click->bottom-sheet-trigger#fire"
export default class extends Controller {
  fire() {
    window.dispatchEvent(new CustomEvent("bottom-sheet:open"));
  }
}
